import { render, staticRenderFns } from "./VamosPaLaCalleActividades.vue?vue&type=template&id=8fd2b3e4&scoped=true"
import script from "./VamosPaLaCalleActividades.vue?vue&type=script&setup=true&lang=js"
export * from "./VamosPaLaCalleActividades.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd2b3e4",
  null
  
)

export default component.exports